module.exports = __webpack_public_path__ + "img/27_ancillary.1840c19a.jpg";